import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useLoaderData, useNavigate } from "react-router-dom";
import MainLayout1 from "Components/UI/Layout/MainLayout1";
import {
  createPrintedInvoicePrintFile,
  getAllEndcustomerArticles,
  getBooks,
} from "API/swesum";
import AddIcon from "@mui/icons-material/Add";
import EndcustomerArticlesTableContainer from "Components/Article/EndcustomerArticlesTableContainer";
import {
  AccountChartsContextProvider,
  useAccountCharts,
} from "Context/AccountCharts";

export default function EndcustomerArticles() {
  const navigate = useNavigate();
  const [endCustomerArticles, setEndCustomerAticles] = useState([]);
  const { fetchAccountCharts } = useAccountCharts();

  useEffect(() => {
    const asyncFetchEndCustomerArticles = async () => {
      fetchAccountCharts();
      const endcustomerArticles = await getAllEndcustomerArticles();
      setEndCustomerAticles(endcustomerArticles);
    };
    asyncFetchEndCustomerArticles();
  }, []);

  return (
    <>
      <MainLayout1>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1.0rem",
          }}
        >
          <Typography variant="h5">Slutkundsartiklar</Typography>
          <Button
            onClick={() => navigate("create")}
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
          >
            SKAPA NY
          </Button>
        </Box>
        <EndcustomerArticlesTableContainer articles={endCustomerArticles} />
      </MainLayout1>
    </>
  );
}
